<template>
  <div>
    <Header :page="page" />

    <div
      v-if="loading"
      class="container mx-auto py-4"
    >
      <div class="text-center my-3">
        <i class="fa fa-spinner fa-spin text-2xl text-gray-500" />
      </div>
    </div>
    <slot v-else />

    <Footer />

    <LoginModal
      v-if="showLoginModal"
      :fields="loginFields"
      @close="showLoginModal = false"
    />

    <Notifications />

    <TwitchStream
      v-if="$page.props.settings.twitch && $page.props.settings.show_stream"
      :twitch-url="$page.props.settings.twitch_url"
    />
  </div>
</template>

<script>
import Header from '../Partials/Header';
import Footer from '../Partials/Footer';
import Notifications from '../Partials/Notifications';
import LoginModal from '../Modals/LoginModal';
import TwitchStream from '../Partials/TwitchStream.vue';

export default {
  components: {LoginModal, Header, Footer, Notifications, TwitchStream},

  props: {
    page: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      loginFields: {},
      showLoginModal: false,

      loading: false,
    };
  },

  mounted () {
    this.$eventHub.$on('login', this.showLogin);
    this.$eventHub.$on('loading', this.loader);
  },

  destroyed () {
    this.$eventHub.$off('login', this.showLogin);
    this.$eventHub.$off('loading', this.loader);
  },

  methods: {
    showLogin(fields = {}) {
      this.loginFields = fields;
      this.showLoginModal = true;
    },

    loader() {
      this.loading = true;
    },
  },
};
</script>
